import { AUTH_BASE_URL } from '../config/api';

const API_BASE_URL = AUTH_BASE_URL;

/**
 * Get all connected Google Business Profile accounts for the user
 */
export const getGBPAccounts = async () => {
  const response = await fetch(`${API_BASE_URL}/api/google-business/accounts`, {
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Failed to fetch GBP accounts');
  }

  return response.json();
};

/**
 * Initiate OAuth flow for a new Gmail account
 */
export const initiateGBPAuth = async () => {
  const response = await fetch(`${API_BASE_URL}/api/google-business/auth`, {
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Failed to initiate auth');
  }

  const { authUrl } = await response.json();
  return authUrl;
};

/**
 * Remove a connected Google Business Profile account
 */
export const removeGBPAccount = async (gmailAccount) => {
  const response = await fetch(`${API_BASE_URL}/api/google-business/accounts/${encodeURIComponent(gmailAccount)}`, {
    method: 'DELETE',
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Failed to remove account');
  }

  return response.json();
};

/**
 * Test connection for a specific Gmail account
 */
export const testGBPConnection = async (gmailAccount) => {
  const response = await fetch(`${API_BASE_URL}/api/google-business/test/${encodeURIComponent(gmailAccount)}`, {
    credentials: 'include'
  });

  if (!response.ok) {
    throw new Error('Failed to test connection');
  }

  return response.json();
};
